/**
 * Copyright 2025 Lumavec Group LLC
 *
 * All rights reserved. No part of this software may be used, copied, modified,
 * or distributed without explicit written permission. This software is provided
 * "as-is" without warranty of any kind, express or implied, including but not
 * limited to warranties of merchantability or fitness for a particular purpose.
 */

import { RefreshCw, Loader } from 'lucide-react';

interface DeploymentListHeaderProps {
  filteredCount: number;
  totalCount: number;
  isLoading: boolean;
  onRefresh: () => void;
}

export function DeploymentListHeader({
  filteredCount,
  totalCount,
  isLoading,
  onRefresh,
}: DeploymentListHeaderProps) {
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center',
      marginBottom: '16px'
    }}>
      <div style={{ fontSize: '14px', color: '#6b7280' }}>
        {filteredCount === totalCount ? (
          <span>{totalCount} deployment{totalCount !== 1 ? 's' : ''}</span>
        ) : (
          <span>
            Showing {filteredCount} of {totalCount} deployment{totalCount !== 1 ? 's' : ''}
          </span>
        )}
      </div>
      
      <button
        onClick={onRefresh}
        disabled={isLoading}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          padding: '8px 12px',
          border: '1px solid #e5e7eb',
          borderRadius: '8px',
          fontSize: '13px',
          backgroundColor: 'white',
          color: '#6b7280',
          cursor: isLoading ? 'not-allowed' : 'pointer',
          transition: 'all 0.2s',
        }}
        onMouseEnter={(e) => {
          if (!isLoading) {
            e.currentTarget.style.backgroundColor = '#f3f4f6';
            e.currentTarget.style.borderColor = '#d1d5db';
          }
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'white';
          e.currentTarget.style.borderColor = '#e5e7eb';
        }}
      >
        {isLoading ? (
          <>
            <Loader size={14} style={{ animation: 'spin 1s linear infinite' }} />
            Refreshing...
          </>
        ) : (
          <>
            <RefreshCw size={14} />
            Refresh
          </>
        )}
      </button>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

